import { render, staticRenderFns } from "./ReferenceViewPage.vue?vue&type=template&id=ac1eae9e&scoped=true"
import script from "./ReferenceViewPage.vue?vue&type=script&lang=js"
export * from "./ReferenceViewPage.vue?vue&type=script&lang=js"
import style0 from "./ReferenceViewPage.vue?vue&type=style&index=0&id=ac1eae9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1eae9e",
  null
  
)

export default component.exports